
import { defineComponent, PropType } from 'vue';

const __default__ = defineComponent({
    name: 'ErrorMessageFormulaire',
    props: {
        message: {
            type: String,
            default: '',
        },
        items: {
            type: Array as PropType<string[]>,
            default: () => [],
        },
        maxHeight: {
            type: String,
            default: '120px',
        },
    },
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "v09045176": (_ctx.maxHeight)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__